export const RouteNames = {
  Dashboard: '',
  Login: 'login',
  Callback: 'auth-code/callback',
  Logout: 'logout',
  SessionExpired: 'session-expired',
  UnAuthorized: 'access-denied',
  MessageView: 'message-view',
  MessageCompose: 'message-compose',
  AccessDenied:'access-denied',
  NoLicense:'no-license'
};

export enum MasterRoutes {
  Okta = '',
  Module = '',
  Home = 'home',
  Callback = 'auth-code/callback',
  Promotions = 'promotions',
  Rebates = 'rebates',
  User = 'user',
  Customer = 'customer-allocation',
  Distribution = 'distribution',
  Messages = 'messages',
  RBC = 'rbc',
  Maintenance ='maintenance',
  SpdPassthru = 'spd-passthru',
  Events='dashboard'
}

export enum Permissions {
  Promotions = 'promotions',
  Rebates = 'rebates',
  Message = 'message',
  Rbc = 'rbc' ,
  User = 'user',
  Spd = 'spdadmin'
}

export const OktaRoutes = {
  Login: {
    Name: RouteNames.Login,
    Url: MasterRoutes.Okta + '/' + RouteNames.Login
  },
  Callback: {
    Name: RouteNames.Callback,
    Url: MasterRoutes.Okta + '/' + RouteNames.Callback
  },
  Logout: {
    Name: RouteNames.Logout,
    Url: MasterRoutes.Okta + '/' + RouteNames.Logout
  },
  SessionExpired: {
    Name: RouteNames.SessionExpired,
    Url: MasterRoutes.Okta + '/' + RouteNames.SessionExpired
  },
  UnAuthorized: {
    Name: RouteNames.UnAuthorized,
    Url: MasterRoutes.Okta + '/' + RouteNames.UnAuthorized
  }
};

export const MessagesRoutes = {
  MessageCompose: {
    Name: RouteNames.MessageCompose,
    Url: MasterRoutes.Messages + '/' + RouteNames.MessageCompose
  },
  MessageView: {
    Name: RouteNames.MessageView,
    Url: MasterRoutes.Messages + '/' + RouteNames.MessageView
  }
};

export const PermissionRoutes = {
  AccessDenied: {
    Name: RouteNames.AccessDenied,
    Url: MasterRoutes.Module + '/' + RouteNames.AccessDenied,
  },
  NoLicense:{
    Name: RouteNames.NoLicense,
    Url: MasterRoutes.Module + '/' + RouteNames.NoLicense,
  }
};